import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from '../styles.scss';
import WorkroomSelect from 'components/formElements/WorkroomSelect';
import FiltersDrawer from 'components/FiltersDrawer';
import ReactSelect from 'components/StyledSelect/react_select';
import { requestDivisionList, requestRegionList, requestMarketList } from 'actionCreators';
import { getMarketList, getDivisionList, getRegionList } from '../../../../reducers';
import { generateSource } from '../../../../utils';

const mapFilterValues = values => values.map(v => v.value);

class StoreFilters extends Component {

  componentWillMount() {
    this.props.requestDivisionList();
    this.props.requestRegionList();
    this.props.requestMarketList();
  }

  handleFilter = (key, value) => {
    const filters = { ...this.props.filters };
    filters[key] = value;
    this.props.handleFilterChange(filters);
  }

  handleWorkrooms = values => this.handleFilter('for_workrooms', mapFilterValues(values));
  handleDivisions = values => this.handleFilter('for_divisions', mapFilterValues(values));
  handleRegions = values => this.handleFilter('for_regions', mapFilterValues(values));
  handleMarkets = values => this.handleFilter('for_markets', mapFilterValues(values));

  render() {
    const { filters, active, reset, divisions, regions, markets } = this.props;
    return (
      <FiltersDrawer
        title="Store"
        active={active}
        toggle={this.props.onOverlayClick}
        reset={reset}
      >
        <WorkroomSelect
          value={filters.for_workrooms}
          onChange={this.handleWorkrooms}
          className={styles.dropdown}
          key="workroom"
        />
        <ReactSelect
          key="divisions"
          className={styles.dropdown}
          label="Divisions"
          name="divisions"
          placeholder="All Divisions"
          multi
          options={generateSource(divisions)}
          value={filters.for_divisions}
          onChange={this.handleDivisions}
        />
        <ReactSelect
          key="regions"
          className={styles.dropdown}
          label="Regions"
          name="regions"
          placeholder="All Regions"
          multi
          options={generateSource(regions)}
          value={filters.for_regions}
          onChange={this.handleRegions}
        />
        <ReactSelect
          key="markets"
          className={styles.dropdown}
          label="Markets"
          name="markets"
          placeholder="All Markets"
          multi
          options={generateSource(markets)}
          value={filters.for_markets}
          onChange={this.handleMarkets}
        />
      </FiltersDrawer>
    );
  }
}

StoreFilters.propTypes = {
  handleFilterChange: PropTypes.func,
  onOverlayClick: PropTypes.func,
  filters: PropTypes.object,
  active: PropTypes.bool,
  reset: PropTypes.func.isRequired,
  requestDivisionList: PropTypes.func.isRequired,
  requestRegionList: PropTypes.func.isRequired,
  requestMarketList: PropTypes.func.isRequired,
  markets: PropTypes.array,
  regions: PropTypes.array,
  divisions: PropTypes.array,
};

const mapStateToProps = state => (
  {
    markets: getMarketList(state),
    regions: getRegionList(state),
    divisions: getDivisionList(state),
  });

export default connect(
  mapStateToProps,
  { requestDivisionList, requestRegionList, requestMarketList },
)(StoreFilters);



// WEBPACK FOOTER //
// ./client/app/shared/components/Filters/StoreFilters/index.jsx